import jsPDF from "jspdf";
import { MeddbasePID } from "../types/meddbase";
import axios from "axios";

export const pushToMeddbase = async (
  content: string,
  meddbasePID: MeddbasePID,
  documentType: string
): Promise<{ success: boolean; hl7Message?: string; meddbaseResponse?: string; error?: unknown }> => {
  try {
    // Remove H1 lines and HTML tags from the content
    const plainTextContent = content
      .replace(/<h1>.*?<\/h1>/g, "")
      .replace(/<[^>]+>/g, "");

    // Create a PDF with text content
    const doc = new jsPDF("portrait", "px", "a4");
    doc.setFontSize(12);
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const xMargin = 35;
    const yMargin = 75;
    const lineHeight = doc.getLineHeight();
    const needNewPageAfterThisYPos = pageHeight - yMargin;

    const wrappedText = doc.splitTextToSize(
      plainTextContent,
      pageWidth - 2 * xMargin
    );
    let yPos = yMargin;
    wrappedText.forEach((line: string) => {
      if (yPos > needNewPageAfterThisYPos) {
        doc.addPage();
        yPos = yMargin;
      } else if (yPos === undefined) {
        yPos = yMargin;
      } else {
        yPos += lineHeight;
      }
      doc.text(line, xMargin, yPos);
    });

    // Convert the PDF to base64
    const base64Content = btoa(doc.output());

    // Generate the document name
    const documentName = generateDocumentName(meddbasePID, documentType);

    const currentDate = new Date();
    const formattedDate = currentDate
      .toISOString()
      .slice(0, 10)
      .replace(/-/g, "");
    const formattedTime = currentDate
      .toISOString()
      .slice(11, 19)
      .replace(/:/g, "");
    const messageNumber = Math.floor(Math.random() * 1000000)
      .toString()
      .padStart(6, "0");
    const messageControlId = `${formattedDate}${formattedTime}${messageNumber}`;

    // Create the HL7 message
    const hl7Message = `MSH|^~\&|generic-file|Motics|Meddbase|systemd1.meddbase.com/241053|${formattedDate}${formattedTime}||ORU^R01|${messageControlId}|D|2.3|||AL|ER|GB||
PID||${meddbasePID.patientID.idNumber}|${meddbasePID.patientID.idNumber}||${meddbasePID.patientName.familyName}^${meddbasePID.patientName.givenName}^^^${meddbasePID.patientName.prefix}||${meddbasePID.dateTimeOfBirth.time}|${meddbasePID.administrativeSex}
ORC||0|||CM||||${formattedDate}${formattedTime}|Motics||
OBR|1|${messageControlId}||||||${formattedDate}${formattedTime}
OBX|1|ED|^${documentName}||PDF^multipart^Octet-Stream^Base64^${base64Content}`;

    // console.log("HL7 message to Meddbase: ", hl7Message);
    // console.log("Posting to Meddbase...");

        // Send HL7 message to Azure Function
        const meddbaseResponse = await axios.post(
          // "https://meddbasedocpush.azurewebsites.net/api/meddbasedocpush",
          "https://meddbasedocpush.azurewebsites.net/api/meddbaseDocPush?code=q0VQtzhSXIyWi5m-3Yvcd9SkMZiboLmz_5rWDAxpEqNfAzFuZnhA7A%3D%3D",
          { hl7Message },
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
    
        // console.log("Meddbase API response:", meddbaseResponse.data);

    // If the push was successful, offer to download the PDF
    // const blob = doc.output("blob");
    // const url = URL.createObjectURL(blob);
    // const link = document.createElement("a");
    // link.href = url;
    // link.download = documentName ?? "motics_summary.pdf";
    // link.click();

    if (meddbaseResponse.status === 200) {
      return { success: true, hl7Message: hl7Message, meddbaseResponse: meddbaseResponse.data, error: null };
    } else {
      return { success: false, hl7Message: hl7Message, meddbaseResponse: meddbaseResponse.data, error: null };
    }
  } catch (error) {
    console.error("Error pushing to Meddbase:", error);
    return { success: false, hl7Message: "", meddbaseResponse: "", error: error };
  }
};

const generateDocumentName = (
  meddbasePID: MeddbasePID,
  documentType: string
): string => {
  const date = new Date().toISOString().split("T")[0];
  return `${documentType}_${meddbasePID.patientName.givenName}_${meddbasePID.patientName.familyName}_${date}.pdf`;
};
